import { useEffect, useState } from "react";

/**
 * Returns whole minutes since `startedAt`. Ticks every 30 s while `isLive` is
 * true; freezes the moment `isLive` flips to false. Safe to call with
 * undefined/null start values (returns 0).
 */
export function useAttendedMinutes(
  startedAt: Date | string | number | null | undefined,
  isLive: boolean,
): number {
  const [minutes, setMinutes] = useState<number>(() =>
    computeMinutes(startedAt),
  );

  useEffect(() => {
    if (!isLive || !startedAt) return;
    const tick = () => setMinutes(computeMinutes(startedAt));
    tick();
    const id = window.setInterval(tick, 30_000);
    return () => window.clearInterval(id);
  }, [startedAt, isLive]);

  return minutes;
}

function computeMinutes(
  startedAt: Date | string | number | null | undefined,
): number {
  if (!startedAt) return 0;
  const startMs =
    startedAt instanceof Date
      ? startedAt.getTime()
      : typeof startedAt === "number"
      ? startedAt
      : Date.parse(String(startedAt));
  if (!Number.isFinite(startMs)) return 0;
  const diff = Date.now() - startMs;
  if (diff <= 0) return 0;
  return Math.floor(diff / 60_000);
}
